<template>
  <div id="googleProvider"></div>
</template>

<script>
export default {
  name: "GoogleProvider",

  inject: ["firebase", "authConfig"],

  created() {
    console.log(this.authConfig);
    this.authConfig.signInOptions.push(
      this.firebase.auth.GoogleAuthProvider.PROVIDER_ID
    );
    console.log(this.authConfig);
  }
};
</script>
